import {
	Input,
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "@/components/primitives";
import { Search } from "lucide-react";
import type { StatusFilter, SortOption } from "../types";

interface FilterControlsProps {
	searchTerm: string;
	onSearchChange: (value: string) => void;
	statusFilter: StatusFilter;
	onStatusFilterChange: (value: StatusFilter) => void;
	sortBy: SortOption;
	onSortByChange: (value: SortOption) => void;
}

export const FilterControls = ({
	searchTerm,
	onSearchChange,
	statusFilter,
	onStatusFilterChange,
	sortBy,
	onSortByChange,
}: FilterControlsProps) => {
	return (
		<div className="mb-6">
			<div className="flex flex-col sm:flex-row gap-4 p-4 rounded-lg bg-white/50 dark:bg-slate-800/50 backdrop-blur-sm border border-border/50">
				<div className="flex-1">
					<div className="relative">
						<Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
						<Input
							placeholder="Search reflections..."
							value={searchTerm}
							onChange={(e) => onSearchChange(e.target.value)}
							className="pl-10"
						/>
					</div>
				</div>
				<Select value={statusFilter} onValueChange={onStatusFilterChange}>
					<SelectTrigger className="w-full sm:w-40">
						<SelectValue placeholder="Filter by status" />
					</SelectTrigger>
					<SelectContent>
						<SelectItem value="all">All</SelectItem>
						<SelectItem value="active">Active</SelectItem>
						<SelectItem value="completed">Completed</SelectItem>
						<SelectItem value="draft">Drafts</SelectItem>
						<SelectItem value="archived">Archived</SelectItem>
					</SelectContent>
				</Select>
				<Select value={sortBy} onValueChange={onSortByChange}>
					<SelectTrigger className="w-full sm:w-40">
						<SelectValue placeholder="Sort by" />
					</SelectTrigger>
					<SelectContent>
						<SelectItem value="newest">Newest First</SelectItem>
						<SelectItem value="oldest">Oldest First</SelectItem>
						<SelectItem value="title">Title A-Z</SelectItem>
					</SelectContent>
				</Select>
			</div>
		</div>
	);
};
